import cx from "classnames";
import React, { useEffect, useState } from "react";
import { useCmsMap } from "../../../context";
import CmsMapLocationModal from "../../CmsMapLocationModal/CmsMapLocationModal";
import { Button } from "../../common";
import * as styles from "./CmsMapCard.module.scss";

export const CmsMapCard: React.FC<DogsTrust.CmsMapCardProps> = ({
	title,
	subTitle,
	location,
	secondaryInfoTitle,
	secondaryInfoText,
	tertiaryInfoText,
	googleMapsUrl,
	ctaUrl,
	ctaLabel,
	onClick,
}) => {
	const { selectedCmsMapName } = useCmsMap();
	const [modalIsOpen, setModalIsOpen] = useState(false);

	const openModal = () => {
		setModalIsOpen(true);
	};

	const closeModal = () => {
		setModalIsOpen(false);
	};

	useEffect(() => {
		if (modalIsOpen) {
			document.getElementsByTagName("body")[0].style.overflow = "hidden";
		} else {
			document.getElementsByTagName("body")[0].style.overflow = "scroll";
		}
		return () => {
			document.getElementsByTagName("body")[0].style.overflow = "scroll";
		};
	}, [modalIsOpen]);

	return (
		<>
			<article
				aria-label={`${title} card`}
				className={cx(styles.cardcontainer, {
					[styles.selected]: selectedCmsMapName === title,
				})}
			>
				<div className={styles.text}>
					<h2 data-variation="hideFromJumpLinks" className={styles.title}>
						{title}
					</h2>
					<p className={styles.subheading}>{subTitle}</p>
				</div>
				<div className={styles.cardsectionbreak} />
				<div className={styles.text}>
					<h3 className={styles.heading}>Location</h3>
					<p className={styles.cardtext}>{location}</p>
					<h3 className={styles.heading}>{secondaryInfoTitle}</h3>
					<p className={cx(styles.cardtext, styles.nomargin)}>
						{secondaryInfoText}
					</p>
				</div>
				<div className={styles.cardsectionbreak} />
				<div className={styles.buttonscontainer}>
					<Button
						variant={"primary"}
						onClick={onClick}
						title={"View on map"}
						size={"small"}
					>
						View on map
					</Button>
					{ctaUrl && ctaLabel && (
						<Button
							variant={"tertiary"}
							url={ctaUrl}
							title={"More information"}
							size={"small"}
						>
							{ctaLabel}
						</Button>
					)}
					{tertiaryInfoText && !ctaUrl && !ctaLabel && (
						<Button
							variant={"tertiary"}
							onClick={openModal}
							title={"Open modal for more information"}
							size={"small"}
						>
							More info
						</Button>
					)}
				</div>
			</article>
			<CmsMapLocationModal
				modalState={modalIsOpen}
				title={title}
				subTitle={subTitle}
				secondaryInfoText={secondaryInfoText}
				secondaryInfoTitle={secondaryInfoTitle}
				tertiaryInfoText={tertiaryInfoText}
				location={location}
				googleMapsUrl={googleMapsUrl}
				onClickCancel={closeModal}
			/>
		</>
	);
};

export default CmsMapCard;
